module.exports = __webpack_public_path__ + "files/9a2df491a5ac7f43816f1b4996f161ad.svg";